import { IStoreState, useAppSelector } from "../../../redux";


export const useLastNodeDetect = (nodeId: string) => {
    const nodes = useAppSelector((storeState: IStoreState) => storeState.automation.graphData.nodes);

    if (nodes.length < 2) {
        return false; // Array has less than 2 elements
    }

    return nodes[nodes.length - 2].id === nodeId;
}